package org.example.project.cleaning

import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.StyleSheet
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.alignSelf
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.boxSizing
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.columnGap
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.gridTemplateColumns
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.lineHeight
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.minHeight
import org.jetbrains.compose.web.css.minWidth
import org.jetbrains.compose.web.css.overflow
import org.jetbrains.compose.web.css.paddingBottom
import org.jetbrains.compose.web.css.paddingTop
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.rowGap
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.css.width

internal object SharedWorkspaceStyle : StyleSheet() {
    val workspace by style {
        display(DisplayStyle.Companion.Flex)
        flexDirection(FlexDirection.Companion.Column)
        alignItems(AlignItems.Companion.Center)
        justifyContent(JustifyContent.Companion.FlexStart)
        width(100.percent)
        height(100.percent)
        minWidth(0.px)
        minHeight(0.px)
        overflow("hidden")
        color(Color.white)
        paddingTop(24.px)
        boxSizing("border-box")
    }

    val side by style {
        display(DisplayStyle.Companion.Flex)
        flexDirection(FlexDirection.Companion.Column)
        minWidth(0.px)
        boxSizing("border-box")
        backgroundColor(Color.transparent)
    }

    val rightTitle by style {
        display(DisplayStyle.Companion.Flex)
        alignItems(AlignItems.Companion.Center)
        justifyContent(JustifyContent.Companion.Center)
    }

    val sectionTitle by style {
        fontSize(24.px)
        fontWeight("700")
        lineHeight("1")
        color(Color.white)
        textAlign("center")
        paddingBottom(60.px)
    }

    val content by style {
        display(DisplayStyle.Companion.Flex)
        flexDirection(FlexDirection.Companion.Column)
        minWidth(0.px)
        minHeight(0.px)
        alignItems(AlignItems.Companion.Center)
        width(100.percent)
        overflow("hidden")
    }

    val contentInner by style {
        width(100.percent)
        maxWidth(1380.px)
        display(DisplayStyle.Companion.Flex)
        flexDirection(FlexDirection.Companion.Column)
        alignItems(AlignItems.Companion.Center)
        minWidth(0.px)
        minHeight(0.px)
        overflow("hidden")
    }

    val textInput by style {
        width(160.px)
        height(42.px)
        backgroundColor(Color.transparent)
        color(Color.white)
        border(0.px)
        property("border-bottom", "1px solid rgba(255,255,255,0.24)")
        property("outline", "none")
        boxSizing("border-box")
        property("caret-color", "white")
        textAlign("center")
    }

    val permissionColumns by style {
        display(DisplayStyle.Companion.Grid)
        boxSizing("border-box")
        justifyContent(JustifyContent.Companion.Center)
        gap(32.px)
        alignItems(AlignItems.Companion.Start)
    }

    val permissionColumn by style {
        display(DisplayStyle.Companion.Flex)
        flexDirection(FlexDirection.Companion.Column)
        minWidth(0.px)
    }

    val centeredDivider by style {
        alignSelf("center")
        width(100.percent)
        maxWidth(1312.px)
        minWidth(0.px)
        boxSizing("border-box")
        height(1.px)
        backgroundColor(rgba(255, 255, 255, 0.14))
        marginTop(40.px)
        marginBottom(40.px)
    }

    val actionBar by style {
        display(DisplayStyle.Companion.Grid)
        gridTemplateColumns("220px repeat(6, minmax(0, 160px))")
        justifyContent(JustifyContent.Companion.Center)
        alignItems(AlignItems.Companion.Center)
        columnGap(22.px)
        rowGap(16.px)
        width(100.percent)
        maxWidth(1312.px)
        boxSizing("border-box")
    }

    val columnList by style {
        display(DisplayStyle.Companion.Flex)
        justifyContent(JustifyContent.Companion.Center)
        width(100.percent)
        paddingBottom(40.px)
    }

    val permissionHeader by style {
        display(DisplayStyle.Companion.Grid)
        gridTemplateColumns("150px 120px")
        gap(2.px)
        alignItems(AlignItems.Companion.Center)
        fontSize(14.px)
        fontWeight("700")
        color(Color("#dfe6f1"))
        paddingBottom(12.px)
    }

    val permissionRow by style {
        display(DisplayStyle.Companion.Grid)
        gridTemplateColumns("150px 120px")
        gap(2.px)
        alignItems(AlignItems.Companion.Center)
        paddingTop(8.px)
        paddingBottom(8.px)
        property("border-bottom", "1px solid rgba(255,255,255,0.08)")
    }

    val permissionName by style {
        color(Color.white)
        fontSize(14.px)
        minWidth(0.px)
        width(150.px)
        property("white-space", "nowrap")
        property("overflow", "hidden")
        property("text-overflow", "ellipsis")
    }

    val permissionSelect by style {
        width(100.percent)
        maxWidth(100.percent)
        height(36.px)
        backgroundColor(Color.transparent)
        color(Color.white)
        border(0.px)
        property("background", "transparent")
        property("box-shadow", "none")
        property("outline", "none")
        property("overflow", "hidden")
    }

    val centeredHeader by style {
        textAlign("left")
    }

}